import i18n from "../../../lang/base";
import { FONT } from "../../../value/staticValues";
import { getTimestampToDate, parseKeyValue, parseLocaleDatetime } from "../../../common/util";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";
import { ReactComponent as RedirImg } from '../../../img/ico-prefix-redir.svg';

import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { ListActionMenu, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import { PAGE_URL } from "../../../value/Url";
import PodProfileAdd from "./PodProfileAdd";
import PodProfileUpdate from "./PodProfileUpdate";
import { DropdownType } from "../../base/CustomDropdown";
import PodProfileContainerAdd from "./PodProfileContainerAdd";
import PodProfileContainerUpdate from "./PodProfileContainerUpdate";
import PodProfileVolumeAdd from "./PodProfileVolumeAdd";
import PodProfileVolumeUpdate from "./PodProfileVolumeUpdate";


export interface PodProfileData {
    pod_profile_id: string;
    pod_profile_name: string;
    pod_profile_description: string;
    deployment_yn: boolean;
    deployment_pod_count: number;
    labels: string;
    annotations: string;
    selector: string;
    template_labels: string;
    container_count: number;
    volume_count: number;
    create_ts: string;
    update_ts: string;
    project: {
      project_id: string;
      project_name: string;
    }
}


export const initPodProfileData = {
    pod_profile_id: '',
    pod_profile_name: '',
    pod_profile_description: '',
    deployment_yn: false,
    deployment_pod_count: 0,
    labels: '',
    annotations: '',
    selector: '',
    template_labels: '',
    container_count: 0,
    volume_count: 0,
    create_ts: '',
    update_ts: '',
    project: {
      project_id: '',
      project_name: '',
    }
}




export interface PodProfileContainerData {
    pod_profile_container_id: string;
    pod_profile_container_name: string;
    pod_profile_container_yaml: string;
    container_image_name: string;
    service_type_code: string;
    request_cpu_count: number;
    request_memory_capacity_mb: number;
    limit_cpu_count: number;
    limit_memory_capacity_mb: number;
    use_gpu_yn: boolean;
    commands: string;
    volume_mounts: string;
    environments: string;
    ports: string;
    liveness_probe_yn: boolean,
    liveness_probe_commands: string;
    liveness_probe_http_get_path: string;
    liveness_probe_http_get_port: number;
    liveness_probe_http_get_headers: string;
    liveness_probe_tcp_socket_port: number;
    liveness_probe_init_delay_sec: number;
    liveness_probe_period_sec: number;
    liveness_probe_timeout_sec: number;
    readiness_probe_yn: boolean;
    readiness_probe_commands: string;
    readiness_probe_http_get_path: string;
    readiness_probe_http_get_port: number;
    readiness_probe_http_get_headers: string;
    readiness_probe_tcp_socket_port: number;
    readiness_probe_init_delay_sec: number;
    readiness_probe_period_sec: number;
    readiness_probe_timeout_sec: number;
    create_ts: string;
    update_ts: string;
}


export interface PodProfileVolumeData {
    pod_profile_volume_id: string;
    pod_profile_volume_name: string;
    pod_profile_volume_type_code: string;
    claim_name: string;
    host_path: string;
    host_path_type_code: string;
    create_ts: string;
    update_ts: string;
}


export interface PodProfileDetailData {
    pod_profile_id: string;
    pod_profile_name: string;
    pod_profile_description: string;
    deployment_yn: boolean;
    deployment_pod_count: number;
    labels: string;
    annotations: string;
    selector: string;
    template_labels: string;
    create_ts: string;
    update_ts: string;
    project: {
      project_id: string;
      project_name: string;
    },
    pod_profile_containers: PodProfileContainerData[]
    pod_profile_volumes: PodProfileVolumeData[]
}


const initPodProfileContainerData = {
    pod_profile_container_id: '',
    pod_profile_container_name: '',
    pod_profile_container_yaml: '',
    container_image_name: '',
    service_type_code: '',
    request_cpu_count: 0,
    request_memory_capacity_mb: 0,
    limit_cpu_count: 0,
    limit_memory_capacity_mb: 0,
    use_gpu_yn: false,
    commands: '',
    volume_mounts: '',
    environments: '',
    ports: '',
    liveness_probe_yn: false,
    liveness_probe_commands: '',
    liveness_probe_http_get_path: '',
    liveness_probe_http_get_port: 0,
    liveness_probe_http_get_headers: '',
    liveness_probe_tcp_socket_port: 0,
    liveness_probe_init_delay_sec: 0,
    liveness_probe_period_sec: 0,
    liveness_probe_timeout_sec: 0,
    readiness_probe_yn: false,
    readiness_probe_commands: '',
    readiness_probe_http_get_path: '',
    readiness_probe_http_get_port: 0,
    readiness_probe_http_get_headers: '',
    readiness_probe_tcp_socket_port: 0,
    readiness_probe_init_delay_sec: 0,
    readiness_probe_period_sec: 0,
    readiness_probe_timeout_sec: 0,
    create_ts: '',
    update_ts: '',
}


const initPodProfileVolumeData = {
    pod_profile_volume_id: '',
    pod_profile_volume_name: '',
    pod_profile_volume_type_code: '',
    claim_name: '',
    host_path: '',
    host_path_type_code: '',
    create_ts: '',
    update_ts: ''
}


export const initPodProfileDetailData = {
    pod_profile_id: '',
    pod_profile_name: '',
    pod_profile_description: '',
    deployment_yn: false,
    deployment_pod_count: 0,
    labels: '',
    annotations: '',
    selector: '',
    template_labels: '',
    create_ts: '',
    update_ts: '',
    project: {
      project_id: '',
      project_name: '',
    },
    pod_profile_containers: [initPodProfileContainerData],
    pod_profile_volumes: [initPodProfileVolumeData]
}




export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("POD_PROFILE_CREATE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "POD_PROFILE_CREATE",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "POD_PROFILE_DELETE",
        },
    },
];

export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("NAME_TEXT"),
        accessor: "pod_profile_name",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("DEPLOYMENT_TEXT"),
        accessor: "deployment_yn",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.blueText}}>{value ? "Y" : 'N'}</div>)
    },
    {
        Header: i18n.t("DEPLOYMENT_COUNT_TEXT"),
        accessor: "deployment_pod_count",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.greenText}}>{value}</div>)
    },
    {
        Header: i18n.t("CONTAINER_COUNT_TEXT"),
        accessor: "container_count",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.purpleText}}>{value}</div>)
    },
    {
        Header: i18n.t("VOLUME_COUNT_TEXT"),
        accessor: "volume_count",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.purpleText}}>{value}</div>)
    },
    {
        Header: i18n.t("LABEL_TEXT"),
        accessor: "labels",
        disableSortBy: true,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (
        <div style={{display: "flex", alignItems: "center",
        }}>
             {
                value?
                <div style={{
                    display: "flex", alignItems: "center", justifyContent: "center",
                    minWidth: 20, height: 20,
                    paddingLeft: 10, paddingRight: 10,
                    marginRight: 4,
                    borderRadius: 10,
                    backgroundColor: "#e6ebf2",
                    fontFamily: FONT.REGULAR,
                    fontSize: 12,
                    color: "#9ea0a5"}}>
                        {value}
                </div>
                : null
            }
        </div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? parseLocaleDatetime(value) : "-"}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.dateContainer}}>{value ? parseLocaleDatetime(value) : "-"}</div>)
    },
];
export const podProfileAddModalContent = {
    title: i18n.t("CONTAINER_POD_PROFILE_CREATE_TEXT"),
    stepCount: 3,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("NEXT_TEXT")
        },
        {
            index: 1,
            prevButtonYn: true,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("NEXT_TEXT")
        },
        {
            index: 2,
            prevButtonYn: true,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <PodProfileAdd />,
}

export const podProfileUpdateModalContent = {
    title: i18n.t("CONTAINER_POD_PROFILE_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <PodProfileUpdate />,
}


export const podProfileAddContainerModalContent = {
    title: i18n.t("CONTAINER_POD_PROFILE_ADD_CONTAINER_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <PodProfileContainerAdd />,
}


export const podProfileUpdateContainerModalContent = {
    title: i18n.t("CONTAINER_POD_PROFILE_UPDATE_CONTAINER_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <PodProfileContainerUpdate />,
}


export const podProfileAddVolumeModalContent = {
    title: i18n.t("CONTAINER_POD_PROFILE_ADD_VOLUME_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <PodProfileVolumeAdd />,
}


export const podProfileUpdateVolumeModalContent = {
    title: i18n.t("CONTAINER_POD_PROFILE_UPDATE_VOLUME_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <PodProfileVolumeUpdate />,
}


export const probeExecTypes:DropdownType[] = [
    {
        label: "Command",
        value: "CMD"
    },
    {
        label: "HTTP-GET",
        value: "HTTPGET"
    },
    {
        label: "TCP-SOCKET",
        value: "TCPSOCK"
    },
]

export const podServiceTypes:DropdownType[] = [
    {
        label: "CLUSTER IP",
        value: "CLTIP"
    },
    {
        label: "NODE PORT",
        value: "NODEPORT"
    },
    {
        label: "LOAD BALANCER",
        value: "LB"
    },
]

export const podVolumeTypes:DropdownType[] = [
    {
        label: "PVC",
        value: "PVC"
    },
    {
        label: "HOST PATH",
        value: "HOSTPATH"
    },
    {
        label: "EMPTY DIR",
        value: "EMTDIR"
    },
]
export const podVolumeHostPathTypes:DropdownType[] = [
    {
        label: "Directory",
        value: "DIR"
    },
    {
        label: "File",
        value: "FILE"
    },
    {
        label: "Directory or Create",
        value: "DIRCRT"
    },
    {
        label: "FILE or Create",
        value: "FILECRT"
    },
    {
        label: "Socket",
        value: "SOCK"
    },
    {
        label: "Char Device",
        value: "CHDEV"
    },
    {
        label: "Block Device",
        value: "BLDEV"
    }
]

const className = {
    statusContainer: {
        width: 56,
        display: "flex", Jusitipy: "center", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    statusImg: {
        marginRight: 3
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 1,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    greenText: {
        color: "#3a8344"
    },
    blueText: {
        color: "#0853fb"
    },
    purpleText: {
        color: "#7066f1"
    },
}